import gql from 'graphql-tag';

/**
 * IMPORTANT - questa e' la schermata di amministrazione generale dei DataViz, quindi deve
 * mostrare ANCHE quelli riservati a un form specifico (oggi solo Trend360, vedi
 * DataVizScope) - altrimenti un editor non potrebbe piu' trovarli per modificarli una
 * volta riservati. Il backend esclude i record riservati di default per ogni altro
 * consumer (sito pubblico, picker non curati).
 *
 * NB - niente default letterale su $filter qui: EntityListFetcher (il solo chiamante,
 * vedi containers/DataVizList.tsx) passa SEMPRE un $filter esplicito, anche {} quando non
 * ci sono campi filtro valorizzati, quindi un default sulla query non scatterebbe mai.
 * `includeScoped: true` va richiesto li' via queryFiltersTransformer.
 */
export const DataVizListQuery = gql`
	query DataVizListQuery(
		$first: Int
		$cursor: String
		$filter: DataVizFilterInput
	) {
		entities: DataViz(first: $first, after: $cursor, filter: $filter) {
			edges {
				node {
					id
					localId
					name
					title
					source
					url
					editorial_section {
						id
						name
					}
					targetSite
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;
